var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandicon = function SvgExpandicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.95 2.37c0-.23.2-.42.42-.42h3.56a.42.42 0 0 1 .3.71L5.05 3.85 7.7 6.52c.17.16.17.42 0 .59l-.59.59a.42.42 0 0 1-.6 0L3.87 5.03 2.68 6.22a.42.42 0 0 1-.73-.3V2.37ZM9.7 13.79a.4.4 0 0 0 .38.26h3.56c.23 0 .41-.19.42-.42v-3.55a.42.42 0 0 0-.71-.3l-1.19 1.19L9.48 8.3a.42.42 0 0 0-.59 0l-.6.6a.42.42 0 0 0 0 .58l2.68 2.67-1.19 1.19a.42.42 0 0 0-.1.45Z",
    clipRule: "evenodd"
  })));
};
export default SvgExpandicon;